import React, { useEffect, useState } from 'react';
import {
  Box,
  Stack,
  Container,
  Typography,
  Snackbar,
  Alert,
  Button,
  TableContainer,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Checkbox,
  IconButton,
  MenuItem,
  Menu,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Pagination,
  PaginationItem,
  Grid,
  Avatar,
  Rating,
  TextField,
  InputAdornment
} from '@mui/material';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import Page from '../../components/Page';
import Iconify from 'src/components/Iconify';
import ClearIcon from '@mui/icons-material/Clear';

//icons
import Empty_Truck from '../../../src/asset/open-door.png';
import { api } from 'src/Api';
import { LoadingButton } from '@mui/lab';
import moment from 'moment';
import { NumericFormat } from 'react-number-format';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import ReactQuill from 'react-quill';
import { TableNoData } from 'src/components/NoData';

export default function BookerProfile() {
  const navigate = useNavigate();
  const location = useLocation();
  const { shipment_id, truck_id } = location.state || {};
  const userData = JSON.parse(localStorage.getItem('user'));

  const [bookerList, setBookerList] = useState([]);

  const [loading, setloading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const [anchorEl, setAnchorEl] = useState(null); // For 3-dot menu control
  const [selectedColumn, setSelectedColumn] = useState(null); // Track which truck is selected for menu

  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = useState(1);

  const [searchLoading, setsearchLoading] = useState(false);
  const [search, setsearch] = useState('');
  const [loadingInvite, setloadingInvite] = useState(false);

  const [message, setMessage] = useState('');
  const [openInviteDialog, setOpenInviteDialog] = useState(false);

  const [roles, setroles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedRating, setSelectedRating] = useState(null);

  useEffect(() => {
    getRoles();
  }, []);

  useEffect(() => {
    if (selectedRole || selectedRating) {
      bookerList.length = 0;
      getBookerProfile(1, selectedRole, selectedRating);
    }
  }, [selectedRole, selectedRating]);

  useEffect(() => {
    if (search.length == 0) {
      bookerList.length = 0;
      getBookerProfile(page);
    }
  }, [search]);

  function getRoles() {
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');

    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    console.log('fetching');
    fetch(api.get_profile_role, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success == true) {
          setroles(result.data);
        }
      })
      .catch((error) => console.log('error', error));
  }

  useEffect(() => {
    getBookerProfile(page);
  }, [page]);

  function getBookerProfile(page, selectedRole, selectedRating) {
    setloading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    search.length > 0 && queryParams.append('search', search);
    page && queryParams.append('page', page);
    queryParams.append('shipment_id', shipment_id || truck_id);
    queryParams.append('profile_type', truck_id ? 'Shipper' : 'Booker');
    selectedRole && queryParams.append('role_id', selectedRole);
    selectedRating && queryParams.append('rating', selectedRating);

    fetch(`${api.get_profiles}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setBookerList(result.data);
          result?.count ? setpagesCount(Math.ceil(result?.count / 10)) : setpagesCount(1);
          setloading(false);
          setsearchLoading(false);
        } else {
          setBookerList([]);
          setpagesCount(0);
          setloading(false);
          setsearchLoading(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setloading(false);
        setsearchLoading(false);
      });
  }

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleMenuClick = (event, truck) => {
    setAnchorEl(event.currentTarget);
    setSelectedColumn(truck); // Set the truck for which menu is open
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedColumn(null); // Reset the selected truck
  };

  const handlePageChange = (event, value) => {
    bookerList.length = 0;
    setPage(value);
    getBookerProfile(value);
  };

  const handleOpenInviteDialog = () => {
    setOpenInviteDialog(true);
    setAnchorEl(null);
  };

  const handleCloseInviteDialog = () => {
    setOpenInviteDialog(false);
    setMessage('');
  };

  function handleSendInvitation() {
    setloadingInvite(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    queryParams.append('request_id', shipment_id || truck_id);
    queryParams.append('request_to_id', selectedColumn?.id);
    queryParams.append('request_by', truck_id ? 'Booker' : 'Shipper');
    message && queryParams.append('message', message);

    fetch(`${api.send_invitation}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          setloadingInvite(false);
          handleMenuClose();
          getBookerProfile(page);
          handleCloseInviteDialog();
        } else {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
          setloadingInvite(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setSnackbarMessage('An error occurred.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setloadingInvite(false);
      });
  }

  return (
    <Page
      title={` ${truck_id ? 'Shipper Profiles' : 'Booker Profiles'} | ${
        process.env.REACT_APP_PROJECTNAME
      }`}
    >
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={2}>
          <IconButton
            style={{
              marginRight: 12,
              height: 40,
              width: 70,
              borderRadius: 5,
              backgroundColor: 'rgba(209,209,209,0.3)'
            }}
            onClick={() => navigate(-1)}
          >
            <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#010f58' }} />
          </IconButton>
          <Typography variant="h4" sx={{ color: '#010f58' }}>
            {truck_id ? 'Shipper Profiles' : 'Booker Profiles'}
          </Typography>
        </Stack>

        <Box
          style={{
            flexDirection: 'column',
            display: 'flex',
            flex: 1,
            marginTop: 10
          }}
          className="top_column"
        >
          <Box
            style={{
              flexDirection: 'row',
              display: 'flex',
              flex: 1
            }}
            className="top_column"
          >
            <Searchbar
              width={'100%'}
              fullWidth
              setFunction={(val) => {
                setsearch(val);
              }}
              className="width_full_property"
              placeholder={'Search Requests'}
              onEnter={() => {
                setsearchLoading(true);
                bookerList.length = 0;
                getBookerProfile();
              }}
            />

            <TextField
              select
              label="Profile Type"
              value={selectedRole}
              onChange={(e) => setSelectedRole(e.target.value)}
              fullWidth
              // error={Boolean(errors.equipmentType)}
              // helperText={errors.equipmentType}

              sx={{ marginLeft: '1.5%', width: '40%' }}
              InputLabelProps={{
                shrink: true, // Force the label to shrink when a value is selected
                style: {
                  fontSize: '11px',
                  lineHeight: '1.2',
                  transform: 'translate(14px, -6px) scale(1)' // Adjust position of label
                }
              }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      paddingTop: 0 // Ensure the dropdown aligns properly
                    }
                  }
                }
              }}
              InputProps={{
                style: {
                  fontSize: 14,
                  height: '40px', // Set the height of the input field
                  padding: '0px 0px' // Add padding to input field
                },
                endAdornment: selectedRole ? (
                  <InputAdornment position="end" sx={{ mr: 3.5 }}>
                    <IconButton
                      size="small"
                      onClick={() => {
                        setSelectedRole('');
                        getBookerProfile(1, '', selectedRating);
                      }} // reset value
                      edge="end"
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ) : null
              }}
              className="width_full_status"
            >
              {roles.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.role_name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              select
              label="Rating"
              value={selectedRating}
              onChange={(e) => setSelectedRating(e.target.value)}
              fullWidth
              sx={{ marginLeft: '1.5%', width: '40%' }}
              InputLabelProps={{
                shrink: true, // Force the label to shrink when a value is selected
                style: {
                  fontSize: '11px',
                  lineHeight: '1.2',
                  transform: 'translate(14px, -6px) scale(1)' // Adjust position of label
                }
              }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      paddingTop: 0 // Ensure the dropdown aligns properly
                    }
                  }
                }
              }}
              InputProps={{
                style: {
                  fontSize: 14,
                  height: '40px', // Set the height of the input field
                  padding: '0px 0px' // Add padding to input field
                },
                endAdornment: selectedRating ? (
                  <InputAdornment position="end" sx={{ mr: 3.5 }}>
                    <IconButton
                      size="small"
                      onClick={() => {
                        setSelectedRating('');
                        getBookerProfile(1, selectedRole, '');
                      }} // reset value
                      edge="end"
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ) : null
              }}
              className="width_full_status"
            >
              {[1, 2, 3, 4, 5].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>

            <LoadingButton
              style={{ width: '15%', marginLeft: '1.5%' }}
              variant="contained"
              className="width_full_status"
              loading={searchLoading}
              onClick={() => {
                setsearchLoading(true);
                setPage(1);
                getBookerProfile(1);
              }}
            >
              <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
            </LoadingButton>
          </Box>
        </Box>

        <TableContainer
          component={Paper}
          sx={{ boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.1)', mt: 2, mb: 2 }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 120 }}>
                  COMPANY
                </TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 110 }}>
                  PROFILE TYPE
                </TableCell>

                {shipment_id && (
                  <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 110 }}>
                    RATING
                  </TableCell>
                )}
                {shipment_id && (
                  <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 110 }}>
                    TOTAL REVIEWS
                  </TableCell>
                )}

                {shipment_id && (
                  <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 110 }}>
                    TOTAL EARNINGS
                  </TableCell>
                )}
                {truck_id && (
                  <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 110 }}>
                    TOTAL SCORE
                  </TableCell>
                )}

                {shipment_id && (
                  <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 110 }}>
                    SUCCESS JOBS
                  </TableCell>
                )}
                {truck_id && (
                  <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 110 }}>
                    SUCCESS SCORE
                  </TableCell>
                )}

                {shipment_id && (
                  <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 110 }}>
                    CANCEL JOBS
                  </TableCell>
                )}
                {truck_id && (
                  <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 110 }}>
                    CANCEL SCORE
                  </TableCell>
                )}

                {shipment_id && (
                  <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 110 }}>
                    PENDING JOBS
                  </TableCell>
                )}
                {truck_id && (
                  <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 150 }}>
                    PENDING SPENDING
                  </TableCell>
                )}
                <TableCell
                  sx={{
                    fontSize: '12px',
                    color: '#010f58',
                    position: 'sticky',
                    right: 0,
                    zIndex: 1,
                    backgroundColor: '#fff',
                    width: 110
                  }}
                >
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>
            {!loading && (
              <TableBody>
                {bookerList.map((val, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell scope="row" padding="normal">
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Avatar alt={val?.company?.company} src={val?.company?.avatar} />
                          <Box style={{ display: 'flex', flexDirection: 'column', width: 120 }}>
                            <Typography variant="subtitle2" flexWrap={'wrap'}>
                              {val?.company?.company || 'N/A'}
                            </Typography>
                          </Box>
                        </Stack>
                      </TableCell>

                      <TableCell>
                        <Typography style={{ fontSize: 12, width: 110 }}>
                          {val?.role?.role_name}
                        </Typography>
                      </TableCell>

                      {shipment_id && (
                        <TableCell>
                          <Typography sx={{ flex: 1, fontSize: 12 }}>
                            <Rating
                              size="small"
                              name="read-only"
                              value={val?.averageRating}
                              readOnly
                            />
                          </Typography>
                        </TableCell>
                      )}

                      {shipment_id && (
                        <TableCell>
                          <Typography style={{ fontSize: 12, width: 110 }}>
                            {val?.total_review_count}
                          </Typography>
                        </TableCell>
                      )}

                      {shipment_id ? (
                        <TableCell>
                          <Typography style={{ fontSize: 12, width: 110 }}>
                            {val?.total_earning}
                          </Typography>
                        </TableCell>
                      ) : (
                        <TableCell>
                          <Typography style={{ fontSize: 12, width: 110 }}>
                            {val?.total_score}
                          </Typography>
                        </TableCell>
                      )}

                      {shipment_id ? (
                        <TableCell>
                          <Typography style={{ fontSize: 12, width: 110 }}>
                            {val?.success_bookings}
                          </Typography>
                        </TableCell>
                      ) : (
                        <TableCell>
                          <Typography style={{ fontSize: 12, width: 110 }}>
                            {val?.success_score}
                          </Typography>
                        </TableCell>
                      )}

                      {shipment_id ? (
                        <TableCell>
                          <Typography style={{ fontSize: 12, width: 110 }}>
                            {val?.cancel_bookings}
                          </Typography>
                        </TableCell>
                      ) : (
                        <TableCell>
                          <Typography style={{ fontSize: 12, width: 110 }}>
                            {val?.cancel_score}
                          </Typography>
                        </TableCell>
                      )}

                      {shipment_id ? (
                        <TableCell>
                          <Typography style={{ fontSize: 12, width: 110 }}>
                            {val?.pending_bookings}
                          </Typography>
                        </TableCell>
                      ) : (
                        <TableCell>
                          <Typography style={{ fontSize: 12, width: 150 }}>
                            {val?.total_spending}
                          </Typography>
                        </TableCell>
                      )}

                      <TableCell
                        style={{
                          position: 'sticky',
                          right: 0,
                          zIndex: 1,
                          background: '#fff'
                        }}
                      >
                        <IconButton onClick={(e) => handleMenuClick(e, val)}>
                          <Iconify icon="iwwa:option" style={{ fontSize: 20, color: '#010f58' }} />
                        </IconButton>

                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={handleMenuClose}
                          sx={{
                            boxShadow: 'none', // Remove shadow completely
                            border: '1px solid #ddd', // Optional: Add a border for a cleaner look
                            borderRadius: '8px' // Optional: Adjust border-radius for rounded corners
                          }}
                          PaperProps={{
                            style: {
                              boxShadow: '0px 2px 4px rgba(152, 152, 152, 0.1)', // Custom shadow
                              borderRadius: '8px' // Keep consistent with the design
                            }
                          }}
                        >
                          {/* <MenuItem sx={{ fontSize: 12 }}>Available Booking</MenuItem> */}
                          <MenuItem sx={{ fontSize: 12 }} onClick={handleOpenInviteDialog}>
                            Invite
                          </MenuItem>
                        </Menu>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            )}

            {/* loader */}
            {loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}

            {/* empty list */}
            {bookerList.length == 0 && !loading && <TableNoData colSpan={10} />}
          </Table>
        </TableContainer>

        {/* Pagination */}
        {!loading && pagesCount > 1 && bookerList.length !== 0 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 20,
              alignItems: 'center',
              marginBottom: 20
            }}
          >
            <Pagination
              color="primary"
              shape="rounded"
              page={page}
              size="small"
              count={pagesCount}
              onChange={handlePageChange}
              renderItem={(item) => <PaginationItem {...item} />}
            />
          </Box>
        )}

        <Dialog open={openInviteDialog} onClose={handleCloseInviteDialog} fullWidth>
          <DialogTitle>Send Invitation</DialogTitle>
          <DialogContent>
            <ReactQuill
              modules={{
                toolbar: [
                  [{ header: [1, 2, false] }],
                  ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                  [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
                  ['link', 'image'],
                  ['emoji'],
                  ['clean']
                ],
                'emoji-toolbar': true,
                'emoji-textarea': false,
                'emoji-shortname': true
              }}
              value={message}
              onChange={setMessage}
              placeholder="Write your message..."
              style={{ marginBottom: 10 }}
            />
          </DialogContent>
          <DialogActions sx={{ paddingRight: 3, paddingBottom: 2 }}>
            <Button onClick={handleCloseInviteDialog} color="primary">
              Cancel
            </Button>
            <LoadingButton
              loading={loadingInvite}
              onClick={handleSendInvitation}
              color="primary"
              variant="contained"
            >
              Send
            </LoadingButton>
          </DialogActions>
        </Dialog>

        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
